if (!customElements.get('kol-swipe')) {
  customElements.define('kol-swipe', class KolSwipe extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        commentSwiper: this.querySelector("[data-comment-swiper]"),
        imageSwiper: this.querySelector("[data-image-swiper]"),
      }
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
      this.commentSwiper = new Swiper(this.elements.commentSwiper, {
        slidesPerView: 1,
        loop: false,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        speed: 500,
        autoHeight: true,
        // effect: "fade",
        // fadeEffect: {
        //   crossFade: true,
        // },
        spaceBetween: 16,
        observer: true,
        observeParents: true,
        controller: {
          control: this.commentSwiper,
        },
        navigation: {
          nextEl: this.elements.commentSwiper.querySelector('.swiper-button-next'),
          prevEl: this.elements.commentSwiper.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
        },
      });
      this.imageSwiper = new Swiper(this.elements.imageSwiper, {
        slidesPerView: 1,
        loop: false,
        centeredSlides: true,
        // centerInsufficientSlides: true,
        // normalizeSlideIndex: false,
        speed: 500,
        spaceBetween: 0,
        // slidesOffsetBefore: 20,
        // slidesOffsetAfter: 20,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.elements.imageSwiper.querySelector('.swiper-button-next'),
          prevEl: this.elements.imageSwiper.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            allowTouchMove: false,
          },
        },
      });
      this.commentSwiper.controller.control = this.imageSwiper;
      this.imageSwiper.controller.control = this.commentSwiper;
      this.initEvent();
    }

    initEvent() {
      const slides = this.elements.imageSwiper.querySelectorAll(".swiper-slide");
      for (const slide of slides) {
        slide.addEventListener("click", () => {
          const index = slide.getAttribute("data-index");
          this.commentSwiper.slideTo(index);
        });
      }
    }
  });
}
